export enum ERole {
  PARENT = 'PARENT',
  SCHOOL = 'SCHOOL',
  TEACHER = 'TEACHER',
  DIRECTOR = 'DIRECTOR',
  ADMIN = 'ADMIN',
  PATROL = 'PATROL',
}
